import { Calendar, FileText, MapPin, Scale, ShieldCheck } from "lucide-react";
const credentials = [{
  icon: FileText,
  text: "ACN: 674 430 070"
}, {
  icon: ShieldCheck,
  text: "ABN: 97674430070"
}, {
  icon: MapPin,
  text: "VIC Registered"
}, {
  icon: Calendar,
  text: "Est. 2024"
}, {
  icon: Scale,
  text: "Corporations Act 2001 Compliant"
}];
export default function ComplianceAndTrustCredentials() {
  return <section id="compliance-and-trust-credentials" className="bg-muted border-y border-border/50 py-3">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 md:justify-between">
          {credentials.map((item, i) => {
          const Icon = item.icon;
          return <div key={i} data-index={i} className="flex items-center gap-2 text-muted-foreground">
                <Icon className="size-3.5 shrink-0" aria-hidden="true" />
                <span className="font-sans text-xs font-medium uppercase tracking-widest">
                  {item.text}
                </span>
              </div>;
        })}
        </div>
      </div>
    </section>;
}